module.exports = __webpack_public_path__ + "assets/img/title-recom-config-7f65cae0.png";